import React, { useEffect, useState } from "react";

import banner from "../assets/images/aboutus-banner.png";
import mobileBanner from "../assets/images/aboutus-banner-mobile.png";
import AboutUs from "../components/AboutUs";
import bill from "../assets/icons/bill.svg";
import dollar from "../assets/icons/dollar.svg";
import coin from "../assets/icons/coin.svg";

const AboutUsPage = () => {
  const [imageSrc, setImageSrc] = useState(banner);

  useEffect(() => {
    const updateImageSrc = () => {
      if (window.innerWidth <= 580) {
        setImageSrc(mobileBanner);
      } else {
        setImageSrc(banner);
      }
    };

    updateImageSrc(); // Check on mount
    window.addEventListener("resize", updateImageSrc);

    return () => {
      window.removeEventListener("resize", updateImageSrc);
    };
  }, []);

  return (
    <div className="mx-[8.84rem] max-[580px]:mx-[2.75rem]">
      <div className="">
        <img
          className="mx-auto mt-[2.5rem]"
          src={imageSrc}
          alt="aboutus-banner"
        />
      </div>
      <div className="aboutus-page-container">
        <div className="head flex flex-col justify-center items-center gap-[1rem]">
          <div className="title">درباره صرافی IEX</div>
          <div className="desc">
            شرکت تضامنی صرافی محبوبه اشراقی و شرکا با نام تجاری صرافی آی‌اکس با
            مجوز رسمی از بانک مرکزی جمهوری اسلامی ایران به شماره ثبت 510283،
            فعالیت خود را از تاریخ 1396/3/13 آغاز کرده است. صرافی ما با فعالیت
            موفق در زمینه خرید و فروش سکه و ارز و انجام حواله‌جات ارزی وهمچنین
            فعالیت‌ در زمینه کارگزاری ارزی خارجی، توانست در مدت زمان کوتاهی به
            سهم قابل توجهی از بازار رسمی این حوزه دست یابد و جایگاه ویژه‌ای در
            ارائه خدمات حرفه‌ای و متعهدانه به مشتریان عزیز ایجاد کند. ما بر این
            باوریم که صداقت، ارائه قیمت‌های رقابتی و انتقال وجه سریع و مطمئن
            پایه‌های اصلی جلب رضایت مشتریان عزیز است. به همین دلیل همواره تلاش
            می‌کنیم در تمام مراحل مبادلات مالی همراه و پشتیبان شما عزیزان باشیم.
            اعتماد شما، سرمایه ماست تیم ما با بهره‌گیری از مدیران مجرب،
            کارشناسان حرفه‌ای، و پیشرفته‌ترین پروتکل‌های امنیتی، اطمینان حاصل
            می‌کند که معاملات شما در محیطی امن و مطمئن انجام شود. این اعتماد
            ارزشمند صرافی آی‌اکس را به یکی از معتبرترین مجموعه‌های صرافی، سکه و
            ارز تبدیل کرده است. با ما همراه شوید و تجربه‌ای متفاوت از معاملات
            سکه و ارز را رقم بزنید.
          </div>
        </div>
        <div className="cards-container flex justify-center items-center gap-[1.94rem] my-[3.35rem] max-[580px]:flex-col">
          <div className="card">
            <img src={bill} alt="" />
            <div className="max-[580px]:flex justify-center items-center flex-col">
              <div className="title">خرید و فروش اسکناس</div>
              <div className="desc">
                خرید و فروش انواع اسکناس های رایج دنیا در صرافی آی اکس
              </div>
            </div>
          </div>
          <div className="card">
            <img src={coin} alt="" />
            <div className="max-[580px]:flex justify-center items-center flex-col">
              <div className="title">خرید و فروش سکه</div>
              <div className="desc">خرید و فروش انواع سکه و مسکوکات بانکی</div>
            </div>
          </div>
          <div className="card">
            <img src={dollar} alt="" />
            <div className="max-[580px]:flex justify-center items-center flex-col">
              <div className="title">خرید ارز</div>
              <div className="desc">
                خرید ارز حاصل از صادرات به بالاترین نرخ
              </div>
            </div>
          </div>
        </div>
        <div className="notif">
          به اطلاع می رساند که فعالیتهای ارزی این صرافی صرفا در چهار چوب قوانین
          بانک مرکزی می باشد این وب سایت صرفا جهت اطلاع رسانی است و هیچ گونه
          خرید و فروشی در آن انجام نمی پذیرد، مشتریان محترم برای انجام خرید و
          فروش به صرافی مراجعه نمایند.
        </div>
      </div>
    </div>
  );
};

export default AboutUsPage;
